import React, { useEffect, useState, useRef } from "react";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import { commaSeparateAmount } from './commaSeparate';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  withStyles,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  TablePagination,
  Radio,
  TableContainer,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Backdrop,
  Typography,
  Box,
  Button
} from "@material-ui/core";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from "../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    background: "blue",
  },
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
  submitButton: {
    backgroundColor: "#F47E46 !important", // Decorpot Orange
    color: "white", // White text
    "&:hover": {
      backgroundColor: "#E0663D !important", // Darker Orange on hover
    },
  },
  searchButton: {
    background: "#F47E46",
    color: "#fff",
    height: 42,
    minWidth: 120,
    borderRadius: 8,
    fontWeight: 600,
  },

  clearButton: {
    background: "#f5f5f5",
    color: "#333",
    border: "1px solid #d9d9d9",
    height: 42,
    minWidth: 120,
    borderRadius: 8,
    fontWeight: 600,
  },

  downloadButton: {
    backgroundColor: "#2E7D32",
    color: "#fff",
    height: 42,
    minWidth: 180,
    borderRadius: 8,
    fontWeight: 600,
  },
  tableHeaderCell: {
    textAlign: "center",
    fontWeight: 700,
    backgroundColor: "#1C375D",
    color: "#fff",
    border: "1px solid #D3D3D3",
  },

  tableCell: {
    border: "1px solid #D3D3D3",
  },
  dashboardCard: {
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    marginBottom: 20,
  },

  headerCard: {
    borderRadius: 12,
    marginBottom: 20,
    background:
      "linear-gradient(135deg, #1C375D 0%, #2B5AA7 100%)",
    color: "#fff",
  },

  filterPaper: {
    padding: 24,
    borderRadius: 12,
    marginBottom: 20,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  },

  actionButton: {
    height: 45,
    minWidth: 140,
    fontWeight: 600,
    borderRadius: 8,
  },
  tableContainer: {
    maxHeight: "70vh",
    borderRadius: 12,
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "#f5f8fc",
    },
  },

  noData: {
    padding: 40,
    textAlign: "center",
    fontSize: 16,
    color: "#777",
  },
}));

const ChannelPartnerMeetingData = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [storeDateFilter, setPivotDateFilters] = useState({
    startDate: "",
    endDate: "",
    dateType: "meetingDate",
  });
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const [selectedFilterOption, setSelectedFilterOption] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [data, setData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const buttonRef = useRef(null);
  const [leadStatusData, setLeadStatusData] = useState([])
  const searchTypes = [
    "Customer Name",
    "Email ID",
    "Lead No",
    "Project No",
    "Contact No",
    "Unique Lead No",
  ];
  const [loading, setLoadingState] = useState(false);

  const headers = [
    { key: "serialNo", label: "Sl. No." },
    { key: "projectNo", label: "Project No" },
    { key: "leadNumber", label: "Lead No" },
    { key: "customerName", label: "Customer Name" },
    { key: "createdAt", label: "Created At" },
    { key: "leadAssignedDate", label: "Lead Assigned Date" },
    { key: "sourceOfLead", label: "Source Of Lead" },
    { key: "salesUser", label: "Sales User" },
    { key: "salesAssistantManager", label: "Sales Assistant Manager" },
    { key: "salesManager", label: "Sales Manager" },
    { key: "salesAGM", label: "Sales AGM" },
    { key: "salesDGM", label: "Sales DGM" },
    { key: "salesValue", label: "Value (INR)" },
    { key: "city", label: "City" },
    { key: "experienceCenter", label: "Experience Center" },
    { key: "meetingType", label: "Meeting Type" },
    { key: "meetingDate", label: "Meeting Date" },
    { key: "salesWonDate", label: "Sales Won Date" },
    { key: "designKOMInternalDate", label: "Design KOM Internal Date" },
    { key: "designSignOffDate", label: "Design Sign-Off Date" },
    { key: "tokenPercent", label: "Token Percent" },
  ];

  const csvDownloadHandler = async (data) => {
    props.setLoading(true);

    try {
      const csvArray = data.map((item, index) => ({
        serialNo: index + 1,

        projectNo: item?.erpProjectNo || "N/A",

        leadNumber: item?.lead_no || "N/A",

        customerName: item?.customerId?.name || "N/A",

        createdAt: item?.createdAt
          ? moment(item.createdAt).format("DD-MM-YYYY")
          : "N/A",

        leadAssignedDate: item?.leadAssignedDate
          ? moment(item.leadAssignedDate).format("DD-MM-YYYY")
          : "N/A",

        sourceOfLead: item?.sourceOfLead?.name || "N/A",

        salesUser: item?.salesUser?.name || "N/A",

        salesAssistantManager:
          item?.salesAssistantManager?.name || "N/A",

        salesManager: item?.salesManager?.name || "N/A",

        salesAGM: item?.salesAGM?.name || "N/A",

        salesDGM: item?.salesDGM?.name || "N/A",

        salesValue: item?.staticSalesWonAmount || "N/A",

        city: item?.cityName || "N/A",

        experienceCenter:
          item?.experienceCenterName || "N/A",

        meetingType:
          item?.meetingWithCustomer?.meetingType || "N/A",

        meetingDate: item?.meetingWithCustomer?.meetingDate
          ? moment(
            item?.meetingWithCustomer?.meetingDate
          ).format("DD-MM-YYYY")
          : "N/A",

        salesWonDate: item?.leadWonDate
          ? moment(item.leadWonDate).format("DD-MM-YYYY")
          : "N/A",

        designKOMInternalDate:
          item?.designKickOffInternalApprovalDate
            ? moment(
              item.designKickOffInternalApprovalDate
            ).format("DD-MM-YYYY")
            : "N/A",

        designSignOffDate:
          item?.customerDesignSignOffDate
            ? moment(
              item.customerDesignSignOffDate
            ).format("DD-MM-YYYY")
            : "N/A",

        tokenPercent: item?.tokenPercent || "N/A",
      }));

      setCsvData(csvArray);
      downloadExcel();
    } catch (error) {
      console.log(error);

      props.setSnackInfo(
        error?.response?.data?.message ??
        "Something went wrong",
        "error"
      );
    }

    props.setLoading(false);
  };

  const downloadExcel = () => {
    props.setLoading(true)
    try {
      setTimeout(() => {
        buttonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    props.setLoading(false)
  }

  const storePivotDate = (e) => {
    const { name, value } = e.target;
    setPivotDateFilters({ ...storeDateFilter, [name]: value });
  };

  useEffect(() => {
    fetchChannelPartnerReportData();
  }, []);

  const handleSubmitButton = () => {
    fetchChannelPartnerReportData(storeDateFilter);
  };

  const clearDateFilter = () => {
    const clearedFilters = {
      startDate: "",
      endDate: "",
      dateType: "meetingDate",
    };

    setSearchInput("");
    setSelectedSearchType("");
    setPivotDateFilters(clearedFilters);

    fetchChannelPartnerReportData(clearedFilters);
  };


  const fetchChannelPartnerReportData = async (filters = storeDateFilter) => {
    setLoadingState(true);
    try {
      const obj = {
        startDate: filters.startDate,
        endDate: filters.endDate,
        dateType: filters.dateType || "meetingDate",
      };

      const response = await HttpService.fetchChannelPartnerReportData(obj);

      setData(response?.data?.data || []);
      setLeadStatusData(response?.data?.data || []);
    } catch (err) {
      props.setSnackInfo("Something went wrong", "error");
    } finally {
      setLoadingState(false);
    }
  };

  const reportTitle =
    storeDateFilter.dateType === "salesWonDate"
      ? "Channel Partner Sales Won Report"
      : "Channel Partner Meeting Report";

  return (
    <div style={{ padding: 20 }}>
      <Backdrop
        open={loading}
        style={{
          zIndex: 9999,
          color: "#fff",
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Header */}

      <Card className={classes.headerCard}>
        <CardContent>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography
                variant="h5"
                style={{
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                {reportTitle}
              </Typography>
            </Grid>

            <Grid item>
              <Button
                startIcon={<GetAppIcon />}
                className={classes.downloadButton}
                onClick={() => csvDownloadHandler(data)}
              >
                Download CSV
              </Button>

              <CSVLink
                headers={headers}
                filename={
                  storeDateFilter.dateType === "salesWonDate"
                    ? "ChannelPartnerSalesWonReport.csv"
                    : "ChannelPartnerMeetingReport.csv"
                }
                data={csvData}
                ref={buttonRef}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Filters */}

      <Paper className={classes.filterPaper}>
        <Typography
          variant="h6"
          style={{
            marginBottom: 20,
            fontWeight: 600,
          }}
        >
          Filters
        </Typography>

        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label="Date Type"
              name="dateType"
              value={storeDateFilter.dateType}
              onChange={storePivotDate}
            >
              <MenuItem value="meetingDate">
                Meeting Date
              </MenuItem>

              <MenuItem value="salesWonDate">
                Sales Won Date
              </MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              type="date"
              label="From Date"
              name="startDate"
              value={storeDateFilter.startDate}
              onChange={storePivotDate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              type="date"
              label="To Date"
              name="endDate"
              value={storeDateFilter.endDate}
              onChange={storePivotDate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              className={classes.searchButton}
              onClick={handleSubmitButton}
            >
              Search
            </Button>
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              className={classes.clearButton}
              onClick={clearDateFilter}
            >
              Clear
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Data Table */}

      <Card className={classes.dashboardCard}>
        <CardContent>
          <TableContainer
            component={Paper}
            className={classes.tableContainer}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeaderCell}>
                    Sl No
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Project No
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Lead No
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Customer Name
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Created At
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Lead Assigned Date
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Source Of Lead
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Sales User
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Sales Assistant Manager
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Sales Manager
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Sales AGM
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Sales DGM
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Value (INR)
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    City
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Experience Center
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Meeting Type
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Meeting Date
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Sales Won Date
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Design KOM Internal Date
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Design Sign-Off Date
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell}>
                    Token Percent
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data?.length > 0 ? (
                  data
                    .slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((row, i) => (
                      <TableRow
                        hover
                        key={row?._id}
                        className={classes.tableRow}
                      >
                        <TableCell className={classes.tableCell} align="center">
                          {page * rowsPerPage + i + 1}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {row?.erpProjectNo || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Link
                            target="_blank"
                            to={`/project-logs/${row?._id}`}
                            style={{
                              color: "#1976d2",
                              fontWeight: 600,
                            }}
                          >
                            {row?.lead_no}
                          </Link>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.customerId?.name || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.createdAt
                            ? moment(
                              row.createdAt
                            ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.leadAssignedDate
                            ? moment(
                              row.leadAssignedDate
                            ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.sourceOfLead?.name || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.salesUser?.name || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.salesAssistantManager?.name || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.salesManager?.name || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.salesAGM?.name || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.salesDGM?.name || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.staticSalesWonAmount || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.cityName || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.experienceCenterName || "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.meetingWithCustomer?.meetingType ||
                            "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.meetingWithCustomer?.meetingDate
                            ? moment(
                              row.meetingWithCustomer.meetingDate
                            ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.leadWonDate
                            ? moment(
                              row.leadWonDate
                            ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.designKickOffInternalApprovalDate
                            ? moment(
                              row.designKickOffInternalApprovalDate
                            ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.customerDesignSignOffDate
                            ? moment(
                              row.customerDesignSignOffDate
                            ).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row?.tokenPercent || "-"}
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={11}>
                      <div className={classes.noData}>
                        No Records Found
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={data?.length || 0}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(e, newPage) =>
              setPage(newPage)
            }
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={[20, 50, 100, 200]}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(ChannelPartnerMeetingData);
